import React, { useEffect, useRef } from 'react';
import './Representants.css';
import { Phone, MapPin, Mail, Globe, User, Building, MessageCircle, ExternalLink, Map, Flag } from 'lucide-react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
const Representants = () => {
  const containerRef = useRef(null);

  // Données des représentants
  const representants = [
    {
      id: 1,
      name: "Doumbia Nelly",
      country: "Côte d'Ivoire",
      flag: "🇨🇮",
      informations: [
        "Directrice Régionale",
        "Zone Afrique de l'Ouest",
        "Expertise: Relations Internationales & Partenariats"
      ],
      phone: "+225 07 58 82 36 39",
      address: "Cocody Angré, Abidjan",
      email: "nelly.doumbia@etaf.fr",
      whatsapp: "+2250758823639"
    },
    {
      id: 2,
      name: "Camille",
      country: "République Démocratique du Congo",
      flag: "🇨🇩",
      informations: [
        "Directeur National",
        "Zone Afrique Centrale",
        "Expertise: Développement des Affaires"
      ],
      phone: "+243 99 38 78 792",
      address: "Kinshasa, RDC",
      email: "camille@etaf.fr",
      whatsapp: "+243993878792"
    },
    {
      id: 3,
      name: "Tasta",
      country: "Sénégal",
      flag: "🇸🇳",
      informations: [
        "Chargé de Mission",
        "Zone Afrique Francophone",
        "Expertise: Partenariats Stratégiques"
      ],
      phone: "+221 77 123 45 67",
      address: "Dakar, Sénégal",
      email: "tasta@etaf.fr",
      whatsapp: "+221771234567"
    },
    {
      id: 4,
      name: "Doumbia Donia",
      country: "Côte d'Ivoire",
      flag: "🇨🇮",
      informations: [
        "Responsable Administrative",
        "Support Clients & Coordination",
        "Expertise: Service Client International"
      ],
      phone: "+225 07 69 49 59 69",
      address: "Cocody Angré, Abidjan",
      email: "donia.doumbia@etaf.fr",
      whatsapp: "+2250769495969"
    }
  ];

  // Contacts centraux
  const centralContacts = [
    {
      id: 1,
      name: "Vanelly",
      title: "Représentant Congo",
      icon: <Globe size={20} />,
      details: [
        { icon: <Phone size={18} />, text: "+243 993 878 792", link: "tel:+243993878792" },
        { icon: <Mail size={18} />, text: "vanelly@etaf.fr", link: "mailto:vanelly@etaf.fr" },
        { icon: <MapPin size={18} />, text: "Kinshasa, République Démocratique du Congo" }
      ]
    },
    {
      id: 2,
      name: "Doumbia Agence",
      title: "Agence Représentante",
      icon: <Building size={20} />,
      details: [
        { icon: <Phone size={18} />, text: "+225 07 69 49 59 69", link: "tel:+2250769495969" },
        { icon: <Mail size={18} />, text: "agence@etaf.fr", link: "mailto:agence@etaf.fr" },
        { icon: <MapPin size={18} />, text: "Cocody Angré, Abidjan, Côte d'Ivoire" }
      ]
    },
    {
      id: 3,
      name: "Support ETAF France",
      title: "Siège Social - Marseille",
      icon: <Flag size={20} />,
      details: [
        { icon: <Phone size={18} />, text: "+33 6 95 74 40 27", link: "tel:+33695744027" },
        { icon: <MessageCircle size={18} />, text: "WhatsApp", link: "https://wa.me/33695744027" },
        { icon: <MapPin size={18} />, text: "Place de l'hôtel des Postes, 13001 Marseille, France" },
        { icon: <Mail size={18} />, text: "contact@etaf.fr", link: "mailto:contact@etaf.fr" }
      ]
    }
  ];

  // Format WhatsApp URL
  const getWhatsAppUrl = (phone) => {
    const cleanPhone = phone.replace(/\s+/g, '').replace('+', '');
    return `https://wa.me/${cleanPhone}`;
  };

  // Effet d'animation d'entrée
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }
        });
      },
      { threshold: 0.1 }
    );

    const cards = document.querySelectorAll('.representant-card, .contact-card');
    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="representants-sectionbigcontain" id="representants" ref={containerRef}>
         <Header />
    <section className="representants-section" id="representants" ref={containerRef}>
        
      <div className="representants-gradient-overlay" />
      
      <div className="representants-wrapper">
        <div className="representants-header">
          <h1 className="representants-title">Nos Représentants</h1>
          <p className="representants-intro">
            Notre réseau d'experts dédiés à votre réussite à travers l'Afrique et l'Europe.
            Contactez directement nos représentants pour un accompagnement personnalisé.
          </p>
        </div>

        {/* Grille des représentants */}
        <div className="representants-grid">
          {representants.map((representant) => (
            <div className="representant-card" key={representant.id}>
              <div className="card-shine" />
              
              <div className="card-header">
                <div className="flag-icon">{representant.flag}</div>
                <div>
                  <h2 className="representant-name elegant-underline">{representant.name}</h2>
                  <p className="representant-country">
                    <MapPin size={16} />
                    {representant.country}
                  </p>
                </div>
              </div>

              <div className="card-content">
                <div className="info-section">
                  <div className="info-title">
                    <User size={18} className="info-icon" />
                    Rôle & Expertises
                  </div>
                  <ul className="info-list">
                    {representant.informations.map((info, index) => (
                      <li key={index} className="info-item">
                        <span className="item-icon">✓</span>
                        {info}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="info-section">
                  <div className="info-title">
                    <Phone size={18} className="info-icon" />
                    Coordonnées
                  </div>
                  <ul className="info-list">
                    <li className="info-item">
                      <Phone size={16} className="item-icon" />
                      <a href={`tel:${representant.phone.replace(/\s+/g, '')}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                        {representant.phone}
                      </a>
                    </li>
                    <li className="info-item">
                      <MapPin size={16} className="item-icon" />
                      {representant.address}
                    </li>
                    <li className="info-item">
                      <Mail size={16} className="item-icon" />
                      <a href={`mailto:${representant.email}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                        {representant.email}
                      </a>
                    </li>
                  </ul>
                </div>

                <a
                  href={getWhatsAppUrl(representant.phone)}
                  className="contact-badge"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <MessageCircle className="whatsapp-icon" />
                  Contacter sur WhatsApp
                  <ExternalLink size={14} />
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Section contacts centraux */}
        <div className="contact-section">
          <h3 className="contact-title">Contacts Centraux</h3>
          <div className="contact-grid">
            {centralContacts.map((contact) => (
              <div className="contact-card" key={contact.id}>
                <h4 className="contact-name">
                  {contact.icon}
                  {contact.name}
                </h4>
                <p style={{ color: '#666', marginBottom: '20px', fontSize: '0.95rem' }}>
                  {contact.title}
                </p>
                <div className="contact-info">
                  {contact.details.map((detail, index) => (
                    <div key={index} className="contact-item">
                      <span className="contact-icon">{detail.icon}</span>
                      {detail.link ? (
                        <a 
                          href={detail.link} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          style={{ color: 'inherit', textDecoration: 'none' }}
                          className="elegant-underline"
                        >
                          {detail.text}
                        </a>
                      ) : (
                        <span>{detail.text}</span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Badge ETAF France */}
          <a 
            href="mailto:contact@etaf.fr" 
            className="etaf-badge"
            target="_blank" 
            rel="noopener noreferrer"
          >
            <Building size={32} />
            <div className="etaf-info">
              <div className="etaf-title">ETAF France - Siège Social</div>
              <div className="etaf-details">
                Contactez notre siège à Marseille pour toute information
              </div>
            </div>
            <ExternalLink size={20} />
          </a>

          <div className="section-footer">
            <p className="footer-text">
              Nos représentants sont disponibles du lundi au vendredi, de 9h à 18h (heure locale).
              Pour une réponse immédiate, privilégiez le contact WhatsApp.
            </p>
          </div>
        </div>
      </div>
     
    </section>
      <Footer />
    </section>
  );
};

export default Representants;